import { z } from 'zod';

import {
    ENERGY_DEFAULT_UNIT,
    ENERGY_DEFAULT_VIEW_UNIT,
    ENERGY_UNITS,
    ENERGY_VIEW_UNITS,
    energyConverter,
} from '../../units/energy';
import { AbstractMeasurement } from './AbstractMeasurement';

const unitValidator = z.literal(ENERGY_DEFAULT_UNIT).default(ENERGY_DEFAULT_UNIT);

const validator = z
    .preprocess(
        (data) => {
            if (
                typeof data === 'object' &&
                data !== null &&
                'unit' in data &&
                typeof data.unit === 'string' &&
                'value' in data &&
                typeof data.value === 'number' &&
                ([...ENERGY_VIEW_UNITS] as string[]).includes(data.unit)
            ) {
                return energyConverter.convert({
                    from: data.unit as (typeof ENERGY_VIEW_UNITS)[number],
                    to: ENERGY_DEFAULT_UNIT,
                    value: data.value,
                });
            }

            return data;
        },
        AbstractMeasurement.value.extend({
            unit: unitValidator,
        }),
    )
    .default({ unit: 'J' });

export const EnergyCapacity = {
    validator,
    viewUnits: ENERGY_VIEW_UNITS,
    units: ENERGY_UNITS,
    defaultUnit: ENERGY_DEFAULT_UNIT,
    defaultViewUnit: ENERGY_DEFAULT_VIEW_UNIT,
    unitValidator,
};

export type EnergyCapacity = z.infer<typeof validator>;
